export function calculatedTopographicFields(elements = []) {
    const join = field => [...new Set(elements
        .flatMap(element => element?.hierarchies?.length ? element.hierarchies.map(path => path[field]) : [element?.[field]])
        .filter(value => typeof value === 'string' && value.trim() !== '')
        .map(value => value.trim()))]
        .join(', ') || null;

    return {
        zoneName: join('zoneName'),
        topographicElement1Name: join('topographicElement1Name'),
        monumentName: join('monumentName'),
    };
}

export const schemaFieldExtensionHandlers = [{
    name: 'hera-maintenance-photo',
    match: (_field, layoutConfig = {}) => Boolean(layoutConfig.hera_maintenance_photo),
    transform: (field, _node, layoutConfig = {}, context = {}) => {
        const config = layoutConfig.hera_maintenance_photo ?? {};
        field.type = 'hera-maintenance-photo';
        field.sheetName = context.sheet?.name ?? null;
        field.createMode = context.edit !== true;
        field.accept = config.accept ?? 'image/*';

        return { shouldLoadOptions: false };
    },
}, {
    name: 'hera-maintenance-drawing',
    match: (_field, layoutConfig = {}) => Boolean(layoutConfig.hera_maintenance_drawing),
    transform: field => {
        field.type = 'hidden';
        field.visible = false;
        field.hidden = true;

        return { shouldLoadOptions: false };
    },
}, {
    name: 'hera-maintenance-photo-metadata',
    match: (_field, layoutConfig = {}) => Boolean(layoutConfig.hera_maintenance_photo_metadata),
    transform: field => {
        field.type = 'hidden';
        field.visible = false;
        field.hidden = true;

        return { shouldLoadOptions: false };
    },
}, {
    name: 'hera-topographic-map',
    match: field => field?.form_field_type_id === 'hera-topographic-map'
        || (
            field?.form_field_type_id === 'multiselect'
            && field?.name === 'topographic_elements_3'
        ),
    transform: (field, _node, layoutConfig = {}) => {
        const mapConfig = layoutConfig?.hera_topographic_map ?? layoutConfig?.heraTopographicMap ?? {};
        field.type = 'hera-topographic-map';
        field.endpoint = mapConfig.endpoint || '/api/hera/maintenance/reference-data';
        field.multiple = mapConfig.multiple ?? field.form_field_type_id === 'multiselect';
        field.siteField = mapConfig.siteField ?? mapConfig.site_field ?? 'parkId';

        return { shouldLoadOptions: false };
    },
}];
